export const api_path ='https://apps.sinologistics.co.th/api';
//export const api_path ='http://localhost/sinoapi';
export const url_path ='/s-crm';
export const token ='T5YkeqfcmAAqWkKrMYo3Y7555kfvDzYrpiCjrIO1AZwzRDJMrWy5rzi2721fZuBh';
// export const api_path ='https://apps.sinologistics.co.th/dev-api';
// export const url_path ='/dev-crm';